<template>
  <v-layout align-content-center align-center>
      <v-spacer></v-spacer>
      <GmapMap
        :center="computeCenter"
        :zoom="15"
        map-type-id="roadmap"
        style="width: 500px; height: 300px"
      >
      <GmapMarker
          :position="computeCenter"
          :clickable="false"
          :draggable="this.edittable"
          @click="center=computeCenter"
          @dragend="updateCoordinates"
        />
        <GmapCircle
           :center="computeCenter"
           :radius="circleRadius"
           >
       </GmapCircle>
      </GmapMap>

      <v-spacer></v-spacer>
  </v-layout>
</template>

<script>
  export default {
      props: ['center','edittable', 'circleRadius'],
      data () {
        return {

        }
      },
      computed: {
          computeCenter: function () {
              return {"lat" : parseFloat(this.center.lat), "lng": parseFloat(this.center.lng)}
          }
      },
      methods: {
          updateCoordinates: function(coords) {
              let position = coords['latLng']
              this.$emit('moved', position)
          }
      }

  }
</script>

<style>

</style>
